RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const MIN_LANDSCAPES_FOR_FILTERING = 10;

    views.LandscapeDropdown = Marionette.ItemView.extend({
        template: '#shellLandscapeDropdownTemplate',

        ui: {
            tooltips: '.x-landscape-selector, [data-toggle="tooltip"]',
            addLandscapeBtn: '.x-add-landscape',
            addLandscapeOption: '.x-add-landscape-option',
            dropdownButton: '.x-landscape-selector',
            dropdownMenu: '.dropdown-menu',
            filterInput: '.x-item-filter',
            clearIcon: '.x-clear',
            searchBar: '.item-filter',
            searchIcon: '.x-search'
        },

        className: function () {
            const className = 'dropdown';
            return className;
        },

        events: {
            'click a.landscape': 'onLandscapeClicked',
            'click @ui.addLandscapeOption': 'onAddLandscapeSelected',
            'click @ui.dropdownButton': 'onDropdownToggle',
            'click @ui.clearIcon': 'onClearClicked'
        },

        eventsNotToDebounce: {
            'keyup @ui.filterInput': 'onFilterKeyup'
        },

        initialize: function () {
            const me = this;

            me.listenTo(RivalIQ.state.view, 'change:landscapeName', me.render);
            me.listenTo(RivalIQ.state.user, 'change:landscapes', me.renderLandscapes);
        },

        renderLandscapes: function () {
            const me = this;
            const landscapeId = RivalIQ.state.view.get('landscapeId');

            // NOTE special case for not updating when the current landscape
            // was deleted so we dont update the active name to empty string
            if (!_.find(RivalIQ.state.user.get('landscapes'), {
                id: landscapeId
            })) {
                return;
            }

            me.render();
        },

        templateHelpers: function () {
            const activeLandscapeId = RivalIQ.state.view.get('landscapeId');

            const activeLandscape = _.find(RivalIQ.state.user.get('landscapes'), {
                id: activeLandscapeId
            });
            const landscapes = RivalIQ.state.user.get('landscapes');

            return {
                currentLandscape: {
                    name: _.unescape(activeLandscape?.name)
                },
                landscapes: _.map(landscapes, landscape => {
                    return {
                        id: landscape.id,
                        name: _.unescape(landscape.name),
                        isActive: landscape.id === activeLandscapeId
                    };
                }),
                showAddLandscapeOption: RivalIQ.state.user.can('update', RivalIQ.state.landscape),
                showLandscapeFilter: _.size(landscapes) >= MIN_LANDSCAPES_FOR_FILTERING
            };
        },

        onAddLandscapeSelected: function () {
            const me = this;

            me.handleAddLandscape({
                trigger: 'dropdown'
            });
        },

        onAddLandscapeClicked: function () {
            const me = this;

            me.handleAddLandscape({
                trigger: 'button'
            });
        },

        handleAddLandscape: function (options) {
            const me = this;

            if (RivalIQ.state.account.trialExpired()) {
                return App.execute('show:modal', new App.views.PaywallModal({
                    backdrop: true,
                    blur: false
                }));
            }
            me.hideDropdown();

            RivalIQ.execute('landscape:add', {
                trackingOptions: options
            });
        },

        onLandscapeClicked: function (e) {
            const me = this;

            const $el = $(e.currentTarget);

            e.preventDefault();

            if ($el.hasClass('active')) {

                return;
            }

            me.hideDropdown();

            const landscapeId = parseInt($el.attr('data-id'));

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ActivatedLandscape, {
                id: landscapeId,
                name: $el.html()
            });

            RivalIQ.execute('landscape:load', landscapeId);
        },

        onRender: function () {
            const me = this;

            me.ui.tooltips.tooltip({
                delay: {
                    show: 1500,
                    hide: 0
                },
                container: 'body',
                placement: 'right'
            });
        },

        onDestroy: function () {
            const me = this;

            if (me._onCloseHandler) {
                $(document).off('click', me._onCloseHandler);
            }
        },

        onDropdownToggle: function () {
            const me = this;

            const currentlyShowing = me.ui.dropdownMenu.is(':visible');
            if (currentlyShowing) {
                me.hideDropdown();
            } else {
                me.ui.dropdownMenu.show();
                me.$el.find('li.active').get(0)?.scrollIntoView();

                me._onCloseHandler = (e) => {
                    if (!_.isFunction(me.ui.dropdownMenu.has) || me.ui.dropdownMenu.has(e.target).length) {
                        return;
                    }

                    me.hideDropdown();
                };

                $(document).on('click', me._onCloseHandler);
            }

            return false;
        },

        hideDropdown: function () {
            const me = this;

            me.ui.dropdownMenu.hide();
            $(document).off('click', me._onCloseHandler);
        },

        onShow: function () {
            const me = this;
            me.showAddLandscapeNudge();

            $('li.active').get(0)?.scrollIntoView();
        },

        showAddLandscapeNudge: function () {
            const tourOptions = {
                backdrop: false,
                tourId: 'createNewLandscapeNudge',
                closeButtonText: 'Got it!',
                startDelay: 3000,
                skipAutoEnd: true,
                fixed: true,
                steps: [
                    {
                        element: '.x-add-landscape',
                        backdrop: false,
                        content: 'Create a new landscape to benchmark you and your competitors.',
                        placement: 'right',
                        bodyClass: 'create-landscape-tour-1'
                    }
                ]
            };

            const hasOneLandscape = (_.size(RivalIQ.state.user.get('landscapes')) === 1);
            const hasMultipleSessions = (RivalIQ.state.user.get('sessions') > 1);
            const isInExplorerCloneGroup = RivalIQ.state.account.get('isInExplorerCloneGroup');
            if (hasOneLandscape && hasMultipleSessions && isInExplorerCloneGroup &&
                RivalIQ.state.user.shouldShowTour('createNewLandscapeNudge') &&
                RivalIQ.state.user.can('update', RivalIQ.state.landscape)) {

                RivalIQ.execute('tour:start', tourOptions);
                RivalIQ.state.user.completeTour('createNewLandscapeNudge');
            }
        },

        onFilterKeyup: function () {
            const me = this;
            me.filterLandscapes();
        },

        onClearClicked: function () {
            const me = this;

            me.ui.filterInput.val('');
            me.filterLandscapes();
        },

        filterLandscapes: function () {
            const me = this;

            const filterText = me.ui.filterInput.val().trim().toLocaleLowerCase();
            me.ui.clearIcon.toggleClass('display-none', _.isEmpty(filterText));
            me.ui.searchIcon.toggleClass('display-none', !_.isEmpty(filterText));

            const landscapes = RivalIQ.state.user.get('landscapes');

            _.each(landscapes, function (landscape) {
                const show = _.includes(landscape.name.toLocaleLowerCase(), filterText);
                me.$el.find(`li#landscape-${landscape.id}`).toggleClass('display-none', !show);
            });
        }
    });
});
